export interface Staff {
  id: string;
  name: string;
  businessentityID: string;
  pin: string;
  email: string | null;
  phoneNumber: string | null;
  hourlyRate: number;
  department: DepartmentType;
}

export interface User {
  id: string;
  role: "admin" | "member";
}

export interface StoreLocation {
  id: string;
  name: string;
  timezone: string;
}

export enum ActivityLogType {
  CHECK_IN = "CHECK_IN",
  CHECK_OUT = "CHECK_OUT",
  SALE = "SALE",
}

export enum DepartmentType {
  NAIL = "NAIL",
  MASSAGE = "MASSAGE",
  RECEPTION = "RECEPTION",
  BLOW_DRY = "BLOW_DRY",
}

export interface StaffDailySummary {
  date: string;
  checkedInAt: string | null;
  checkedOutAt: string | null;
  numberOfSales: number;
  totalSalesCard: number;
  totalSalesCash: number;
  totalGiftCard: number;
  totalDeposit: number;
  totalCommisionCard: number;
  totalCommisionCash: number;
  totalTipCard: number;
  totalTipCash: number;
}

export interface ActivityLog {
  id?: string;
  staffID: string;
  storeLocationID: string;
  type: ActivityLogType;
  saleAmountCard: number;
  saleAmountCash: number;
  commissionAmountCard: number;
  commissionAmountCash: number;
  tipAmountCard: number;
  tipAmountCash: number;
  giftCardAmount?: number;
  depositAmount?: number;
  createdAt: string;
  updatedAt?: string;
}

export enum PaymentType {
  CARD,
  CASH,
}

export interface UserToBusinessEntity {
  id: string;
  userId: string;
  businessEntityId: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserToStoreLocation {
  id: string;
  userId: string;
  storeLocationId: string;
  createdAt: string;
  updatedAt: string;
}
